import { render } from "./InputFiderDataContainer.vue?vue&type=template&id=39f4bd15&lang=true"
import script from "./InputFiderDataContainer.vue?vue&type=script&lang=js"
export * from "./InputFiderDataContainer.vue?vue&type=script&lang=js"

import "./InputFiderDataContainer.vue?vue&type=style&index=0&id=39f4bd15&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__